import './sentry';

import { ThemeProvider, themesMap } from '@defa/defa-component-library';
import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import App from './app';
import { CookieConsentProvider } from './contexts/cookie-consent';
import ErrorPage from './error-page';
import { AppLayout } from './fractions/app-layout';
import { updateLocale } from './i18n';
import { Charger } from './screens/charger';
import { LandingPage } from './screens/landing-page';
import { Session } from './screens/session';
import { Summary } from './screens/summary';
import api from './utils/api';
import config from './utils/config';
import { NavigateWithParams } from './utils/navigate-with-params';

const brand = config.brandKey;

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);

const router = sentryCreateBrowserRouter([
    {
        path: '/',
        element: <App />,
        errorElement: (
            <AppLayout>
                <ErrorPage />
            </AppLayout>
        ),
        children: [
            { index: true, element: <LandingPage /> },
            {
                path: '/c/:chargerId',
                element: <NavigateWithParams to={({ chargerId }) => `/${chargerId}`} replace />,
            },
            { path: '/:chargerId', element: <Charger />, loader: api.chargerLoader },
            {
                path: '/:chargerId/session/:userId',
                element: <Session />,
                loader: api.sessionLoader,
            },
            {
                path: '/:chargerId/session/:userId/summary',
                element: <Summary />,
                loader: api.summaryLoader,
            },
        ],
    },
]);

// Setting Application language based on Browser language
updateLocale(navigator.language);

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ThemeProvider theme={themesMap[brand]}>
            <CookieConsentProvider>
                <RouterProvider router={router} />
            </CookieConsentProvider>
        </ThemeProvider>
    </React.StrictMode>
);
